import React from 'react';
import PropTypes from 'prop-types';
import usePageTitle from 'jsx/hooks/usePageTitle';
import PageNavigation from './PageNavigation';
import BreadCrumbs from './Header/BreadCrumbs';
import Flex from './Flex';

const PageHeader = ({ products = [], breadCrumbs = [], breadCrumbsOptions = {}, backbutton, showNav = true, fixedTitle, titleTag, subTitle, rightActions, children }) => {
  const [pageTitle] = usePageTitle(products);
  const title = fixedTitle || pageTitle;

  return (
    <>
      <section className="section  page-header">
        <div className="limit padded">
          {breadCrumbs && <BreadCrumbs products={breadCrumbs} options={breadCrumbsOptions}></BreadCrumbs>}
          <div className="grid">
            <div className="col s10of12">
              {/* Leitarbox */}
              {children}
              <div className="header-back">
                {backbutton && backbutton}
                <div>
                  <Flex>
                    <h1 className="page-title">{title}</h1>
                    {titleTag && titleTag}
                  </Flex>
                  {subTitle && subTitle}
                </div>
              </div>
            </div>
            <div className="col s2of12 text-right">{rightActions}</div>
          </div>
          {showNav && <PageNavigation products={products} />}
        </div>
      </section>
    </>
  );
};

export default PageHeader;

PageHeader.propTypes = {
  products: PropTypes.array,
  children: PropTypes.node,
  showNav: PropTypes.bool,
  backbutton: PropTypes.node,
  fixedTitle: PropTypes.string,
  titleTag: PropTypes.node,
  subTitle: PropTypes.node,
  rightActions: PropTypes.node
};
